export const PREVIEW_DOCUMENT = "PREVIEW_DOCUMENT"
export const CLOSE_DOCUMENT_PREVIEW = "CLOSE_DOCUMENT_PREVIEW"
